import React from "react"
import {
	Grid,
	InputAdornment,
	OutlinedInput
} from "@material-ui/core"

import { BlockConditionEditorInputDefaultProps } from "@/protocols/chatBotConstructor"

const NoInteractionTimeoutInput: React.FC<BlockConditionEditorInputDefaultProps> = (props) => {
	const {
		changeValidation,
		validation
	} = props

	const value = validation.second_param

	return (
		<>
			<Grid
				item
				xs={6}
			>
				<OutlinedInput
					type="number"
					placeholder="30"
					value={value}
					fullWidth
					onChange={(event) => changeValidation({ second_param: event.target.value })}
					endAdornment={(
						<InputAdornment
							position="end"
						>
							minutos
						</InputAdornment>
					)}
				/>
			</Grid>
		</>
	)
}

export default NoInteractionTimeoutInput
